module.exports = {"pathContext":{"name":"OrderItemsTotals","kind":"OBJECT","type":"OBJECT","fields":[{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"count","type":{"kind":"SCALAR","name":"Int","ofType":null}},{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"id","type":{"kind":"SCALAR","name":"ID","ofType":null}}],"description":null,"enumValues":null,"possibleTypes":null}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/object-order-items-totals.json
// module id = 1887
// module chunks = 193700422635951